// extracted by mini-css-extract-plugin
export default {"wrap":"pane_wrap__QcK-P"};